import {MitgliederDomainDto} from '@wba/models/dto/mitglieder-domain-dto';
import {RequestBodyEinkommen} from '@wba/services/api/mitglied/request-body-einkommen.interface';
import {Observable} from 'rxjs';


export abstract class MitgliedService {
  abstract getMitglieder(antragId: string): Observable<MitgliederDomainDto>;

  abstract getMitgliederFuerAnlageEk(antragId: string): Observable<{ id: string, name: string }[]>;

  abstract getEinkommenByMitglied(antragId: string): Observable<RequestBodyEinkommen>;

  abstract updateMitglieder(mitglied, antragId, withCleanup?): Observable<any>;

  abstract updateEinkommen(einkommen, antragId): Observable<any>;

  abstract updateNachweise(antragId, mitglieder: { mitgliedId: string, nachweisId: string }[]): Observable<any>;

  abstract deleteMitglied(mitgliedId, antragId): Observable<any>;

  abstract deleteEinkommen(ids: number[], antragId): Observable<any>;
}
